<template>
  <div class="page-common-container" v-loading="loading">
    <div class="page-common-container-left">
      <pageForm ref="pageForm" :title="$i18n.$t('关系筛选')" :btnName="$i18n.$t('开始发现关系')" :fields="fields" @search="search" />
    </div>
    <div class="page-common-container-right">
      <div class="page-common-container-right-content hasName" style="position: relative;">
        <VisIndex :data="relationData" :lineColors="lineColors" />
        <div class="page-common-container-right-content-no-data" v-if="relationData && relationData.data.length === 0 && relationData.link.length === 0">
          <img src="@/assets/map/no-data.png" alt="">
          <p>{{ $i18n.$t('没有查询到相关的关系') }}</p>
        </div>
      </div>
      <div class="page-common-container-right-list hasName">
        <div class="page-common-container-right-list-title">
          <div class="page-common-container-right-list-title-top">
            <div class="page-common-container-right-list-title-top-name">{{ $i18n.$t('查询结果') }}</div>
            <el-button type="primary" @click.stop="exportData" :disabled="!relationData.data.length || downloadLoading" :loading="downloadLoading">{{ $i18n.$t('导出数据') }}</el-button>
          </div>
          <div class="page-common-container-right-list-title-bottom">{{ $i18n.$t('本次图谱共查询到') }}{{ relationTotal }}{{ $i18n.$t('个节点，') }}{{ recordCount }}{{ $i18n.$t('条关系连边，全部数据请点击“导出数据”按钮导出。') }}</div>
        </div>
        <div class="page-common-container-right-list-content">
          <div class="page-common-container-right-list-content-item" v-for="(per, index) in perList" :key="index">
            <div class="page-common-container-right-list-content-item-title">
              <div class="page-common-container-right-list-content-item-title-name">{{ per.Name }}</div>
              <div class="page-common-container-right-list-content-item-title-count">{{ $i18n.$t('关系数据：') }}{{ per.relation_count }}{{ $i18n.$t('条') }}</div>
            </div>
            <div class="page-common-container-right-list-content-item-table">
              <div class="page-common-container-right-list-content-item-table-head">
                <div class="page-common-container-right-list-content-item-table-head-th" v-for="(th, i) in sideBarConfig[per.labels]" :key="i">{{ th.label }}</div>
              </div>
              <template v-for="(link, j) in per.link_node">
                <div class="page-common-container-right-list-content-item-table-row" :key="j" v-if="per.showMore || (!per.showMore && j < 4)">
                  <div class="page-common-container-right-list-content-item-table-row-td" v-for="(td, i) in sideBarConfig[per.labels]" :key="i">
                    <span v-if="td.key">{{ link[td.key] }}</span>
                    <span v-else>{{ link }}</span>
                  </div>
                  <!-- <div class="page-common-container-right-list-content-item-table-row-td" :title="link.RecordedIn">{{ link.RecordedIn }}</div> -->
                </div>
              </template>
            </div>
            <div class="page-common-container-right-list-content-item-more" v-if="per.link_node.length > 4" @click.stop="per.showMore = !per.showMore">
              <template v-if="per.showMore">
                {{ $i18n.$t('收起') }}
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                {{ $i18n.$t('查看更多') }}
                <i class="el-icon-arrow-down"></i>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { relationDiscovery, exportAction } from '@/api/home'
import { i18n } from '@/i18n'
export default {
  name: 'footPrints',
  meta: {
    title: i18n.$t('发现关系')
  },
  data () {
    let sessionParams = sessionStorage.getItem('discoveringRelationshipsParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    return {
      lineColors: [
        '#987442', '#FF0000', '#2077FC', '#A80326', '#B5756B',
        '#FA8401', '#52B051', '#440459', '#4D6499', '#0B429C',
        '#75C8FC', '#E57394', '#8D3EAC', '#1FDB74', '#849ABA',
        '#A9CAFE', '#C89F24', '#24B9AA', '#FEAAA8', '#C4C54E'
      ],
      fields: [
        {
          type: 'person',
          label: i18n.$t('人物名称'),
          // label: {
          //   placeholder: '全部',
          //   key: 'start_type',
          //   defaultValue: 'Person',
          //   options: [
          //     { label: '人物', value: 'Person' },
          //     { label: '地点', value: 'Address' },
          //     { label: '传记', value: 'Biographie' }
          //   ]
          // },
          placeholder: i18n.$t('请输入人物名称'),
          key: 'start_name',
          defaultValue: sessionParams ? (sessionParams.start_name || '') : null
        },
        {
          type: 'person',
          label: i18n.$t('人物名称'),
          // label: {
          //   placeholder: '全部',
          //   key: 'end_type',
          //   defaultValue: 'Person',
          //   options: [
          //     { label: '人物', value: 'Person' },
          //     { label: '地点', value: 'Address' },
          //     { label: '传记', value: 'Biographie' }
          //   ]
          // },
          placeholder: i18n.$t('请输入人物名称'),
          key: 'end_name',
          defaultValue: sessionParams ? (sessionParams.end_name || '') : null
        }
        // {
        //   type: 'select',
        //   label: i18n.$t('人物设置'),
        //   placeholder: i18n.$t('请选择'),
        //   key: 'is_extension',
        //   clearable: true,
        //   options: [
        //     { label: i18n.$t('显示所有人物'), value: '1' },
        //     { label: i18n.$t('仅显示传记人物'), value: '0' }
        //   ],
        //   defaultValue: '1'
        // }
      ],
      loading: false,
      relationData: {
        data: [],
        link: []
      },
      downloadLoading: false,
      perList: [],
      relationTotal: 0,
      recordCount: 0,
      sideBarConfig: {
        'Person-Person': [
          { label: i18n.$t('节点'), key: 'Name' },
          { label: i18n.$t('记载出处'), key: 'RecordedIn' }
        ],
        'Person-Address': [
          { label: i18n.$t('地点名称'), key: 'Name' },
          { label: i18n.$t('人地关系'), key: 'type' }
        ],
        'Address-Person': [
          { label: i18n.$t('人物名称'), key: 'Name' },
          { label: i18n.$t('人地关系'), key: 'type' }
        ],
        'Person-Biographie': [
          { label: i18n.$t('记载出处'), key: '' }
        ]
      }
    }
  },
  // created () {
  //   this.getPersonRelation({})
  // },
  methods: {
    exportData () {
      const form = this.$refs.pageForm.form || {}
      this.downloadLoading = true
      exportAction({
        ...form,
        start_type: 'Person',
        end_type: 'Person',
        output: 1
      }, {
        responseType: 'blob'
      }).then(res => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(res)
        a.download = i18n.$t('关系发现.xlsx')
        a.click()
        URL.revokeObjectURL(a.href)
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    search (params) {
      sessionStorage.setItem('discoveringRelationshipsParams', JSON.stringify(params))
      this.getPersonRelation({
        ...params,
        start_type: 'Person',
        end_type: 'Person'
      })
    },
    getPersonRelation (params) {
      this.loading = true
      relationDiscovery(params).then(res => {
        this.relationData = {
          data: res.data.data,
          link: res.data.link,
          start_name: params.start_name,
          end_name: params.end_name
        }
        this.relationTotal = this.relationData.data.length
        this.recordCount = res.data.link.length
        this.perList = (res.data.sidebar || []).map(e => {
          return {
            ...e,
            showMore: false
          }
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
